import { type MaybeRef, toValue } from 'vue';

import { getTeam, getTeams } from './api';
import { teamKeys } from './keys';

export const teamQueryOptions = (uuid: MaybeRef<string>) => ({
  queryKey: teamKeys.team(uuid),
  queryFn: () => getTeam(toValue(uuid)).then((data) => data.team),
  enabled: () => !!toValue(uuid),
  staleTime: Infinity,
});

export const teamsQueryOptions = (params?: MaybeRef<{ page?: number; query?: string }>) => ({
  queryKey: teamKeys.teams(params),
  queryFn: () => getTeams(toValue(params)).then((data) => data),
});
